import zhCN from "./zh-CN";
import enUS from "./en-US";
const allLocales = {
    'zh-CN': zhCN,
    'en-US': enUS
};
export default allLocales;
